import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "feed-topbar flex flex-col w-full" }
const _hoisted_2 = { class: "feed-mobile-only flex w-full -mt-0.5" }
const _hoisted_3 = { class: "flex flex-col w-full -mt-4" }
const _hoisted_4 = { class: "desktop-shell-layout" }
const _hoisted_5 = { class: "desktop-shell-nav feed-desktop-only" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "desktop-shell-main" }
const _hoisted_8 = { class: "px-4 py-4 w-full sticky bg-brand-black top-0 z-50 border-b border-brand-dark-gray" }
const _hoisted_9 = {
  key: 0,
  class: "flex h-full w-full"
}
const _hoisted_10 = {
  key: 1,
  class: "flex h-full w-full"
}
const _hoisted_11 = {
  key: 2,
  class: "animate-spin h-6 w-6 m-auto text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_12 = {
  key: 3,
  class: "flex px-4 py-2 pt-4"
}
const _hoisted_13 = {
  key: 0,
  class: "flex flex-col space-y-4 overflow-hidden w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_desktop_topbar = _resolveComponent("desktop-topbar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_nearby_list = _resolveComponent("nearby-list")!
  const _component_search_tags = _resolveComponent("search-tags")!
  const _component_input_field = _resolveComponent("input-field")!
  const _component_user_list_item = _resolveComponent("user-list-item")!
  const _component_feed_desktop_sidebar = _resolveComponent("feed-desktop-sidebar")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { class: "search-page" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_desktop_topbar, {
                  class: "feed-desktop-only",
                  "show-search": false
                }),
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_ion_segment, {
                      onIonChange: _ctx.tabChanged,
                      value: _ctx.tab,
                      class: "relative z-50 w-full",
                      "swipe-gesture": false,
                      mode: "ios"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_segment_button, { value: "nearby" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { class: "flex flex-col space-y-1 items-center py-0.5" }, {
                              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                _createElementVNode("svg", {
                                  class: "w-6 h-6 fill-current",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 384 512"
                                }, [
                                  _createElementVNode("path", { d: "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" })
                                ], -1),
                                _createElementVNode("div", { class: "text-xxs" }, "Nearby", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.enableEvents)
                          ? (_openBlock(), _createBlock(_component_ion_segment_button, {
                              key: 0,
                              value: "clubs"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "flex flex-col space-y-1 items-center py-0.5" }, {
                                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                    _createElementVNode("svg", {
                                      class: "h-5 fill-current",
                                      xmlns: "http://www.w3.org/2000/svg",
                                      viewBox: "0 0 384 512"
                                    }, [
                                      _createElementVNode("path", { d: "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16z" })
                                    ], -1),
                                    _createElementVNode("div", { class: "text-xxs" }, "Clubs", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.enableEvents)
                          ? (_openBlock(), _createBlock(_component_ion_segment_button, {
                              key: 1,
                              value: "hosts"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "flex flex-col space-y-1 items-center py-0.5" }, {
                                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                    _createElementVNode("svg", {
                                      class: "h-5 fill-current",
                                      xmlns: "http://www.w3.org/2000/svg",
                                      viewBox: "0 0 640 512"
                                    }, [
                                      _createElementVNode("path", { d: "M155.6 17.3C163 3 179.9-3.6 195 1.9L320 47.5l125-45.6c15.1-5.5 32 1.1 39.4 15.4l78.8 152.9c28.8 55.8 10.3 122.3-38.5 156.6L556.1 413l41-15c16.6-6 35 2.5 41 19.1s-2.5 35-19.1 41l-71.1 25.9L476.8 510c-16.6 6.1-35-2.5-41-19.1s2.5-35 19.1-41l41-15-31.3-86.2c-59.4 5.2-116.2-34-130-95.2L320 188.8l-14.6 64.7c-13.8 61.3-70.6 100.4-130 95.2l-31.3 86.2 41 15c16.6 6 25.2 24.4 19.1 41s-24.4 25.2-41 19.1L92.2 484.1 21.1 458.2c-16.6-6.1-25.2-24.4-19.1-41s24.4-25.2 41-19.1l41 15 31.3-86.2C66.5 292.5 48.1 226 76.9 170.2L155.6 17.3zm44 54.4l-27.2 52.8L261.6 157l13.1-57.9L199.6 71.7zm240.9 0L365.4 99.1 378.5 157l89.2-32.5L440.5 71.7z" })
                                    ], -1),
                                    _createElementVNode("div", { class: "text-xxs" }, "Hosts", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.enableNsfw)
                          ? (_openBlock(), _createBlock(_component_ion_segment_button, {
                              key: 2,
                              value: "tags"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "flex flex-col space-y-1 items-center py-0.5" }, {
                                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                    _createElementVNode("svg", {
                                      class: "fill-current w-6 h-6",
                                      xmlns: "http://www.w3.org/2000/svg",
                                      viewBox: "0 0 448 512"
                                    }, [
                                      _createElementVNode("path", { d: "M181.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8L197.8 128h95.1l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8L357.8 128H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H347.1L325.8 320H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H315.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.8-58.7H155.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8L90.2 384H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l21.3-128H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3zM187.1 192L165.8 320h95.1l21.3-128H187.1z" })
                                    ], -1),
                                    _createElementVNode("div", { class: "text-xxs" }, "Hashtags", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ion_segment_button, { value: "user" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { class: "flex flex-col items-center space-y-1 py-0.5" }, {
                              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                _createElementVNode("svg", {
                                  class: "fill-current",
                                  width: "18",
                                  height: "19",
                                  viewBox: "0 0 18 19",
                                  xmlns: "http://www.w3.org/2000/svg"
                                }, [
                                  _createElementVNode("path", { d: "M4.5 4.5C4.5 6.981 6.519 9 9 9C11.481 9 13.5 6.981 13.5 4.5C13.5 2.019 11.481 0 9 0C6.519 0 4.5 2.019 4.5 4.5ZM17 19H18V18C18 14.141 14.859 11 11 11H7C3.14 11 0 14.141 0 18V19H17Z" })
                                ], -1),
                                _createElementVNode("div", { class: "text-xxs" }, "People", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onIonChange", "value"])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { "force-overscroll": false }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("nav", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleSearchTabs, (searchTab) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: searchTab.value,
                  type: "button",
                  class: _normalizeClass(["feed-nav-link", { 'feed-nav-link--active': _ctx.tab === searchTab.value }]),
                  onClick: ($event: any) => (_ctx.selectTab(searchTab.value))
                }, [
                  _createElementVNode("span", null, _toDisplayString(searchTab.label), 1)
                ], 10, _hoisted_6))
              }), 128))
            ]),
            _createElementVNode("main", _hoisted_7, [
              (_ctx.tab === 'nearby')
                ? (_openBlock(), _createBlock(_component_nearby_list, {
                    key: 0,
                    embedded: "",
                    class: "flex"
                  }))
                : _createCommentVNode("", true),
              (_ctx.tab === 'clubs')
                ? (_openBlock(), _createBlock(_component_nearby_list, {
                    key: 1,
                    embedded: "",
                    "account-type": "club",
                    class: "flex"
                  }))
                : _createCommentVNode("", true),
              (_ctx.tab === 'hosts')
                ? (_openBlock(), _createBlock(_component_nearby_list, {
                    key: 2,
                    embedded: "",
                    "account-type": "host",
                    class: "flex"
                  }))
                : _createCommentVNode("", true),
              (_ctx.tab === 'tags')
                ? (_openBlock(), _createBlock(_component_search_tags, {
                    key: 3,
                    embedded: "",
                    class: "flex"
                  }))
                : _createCommentVNode("", true),
              (_ctx.tab === 'user')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 4,
                    class: _normalizeClass([{
                    'h-full' : _ctx.peopleLoading || !_ctx.searchResults.length || !_ctx.search
                 }, "flex flex-col w-full"])
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_input_field, {
                        placeholder: "Search by name",
                        "clear-input": true,
                        debounce: 300,
                        modelValue: _ctx.search,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event))
                      }, {
                        "icon-start": _withCtx(() => [...(_cache[6] || (_cache[6] = [
                          _createElementVNode("svg", {
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, [
                            _createElementVNode("path", {
                              d: "M21 21L16.514 16.506L21 21ZM19 10.5C19 12.7543 18.1045 14.9163 16.5104 16.5104C14.9163 18.1045 12.7543 19 10.5 19C8.24566 19 6.08365 18.1045 4.48959 16.5104C2.89553 14.9163 2 12.7543 2 10.5C2 8.24566 2.89553 6.08365 4.48959 4.48959C6.08365 2.89553 8.24566 2 10.5 2C12.7543 2 14.9163 2.89553 16.5104 4.48959C18.1045 6.08365 19 8.24566 19 10.5V10.5Z",
                              stroke: "#FFFFFF",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            })
                          ], -1)
                        ]))]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    (!_ctx.searchResults.length && _ctx.search && !_ctx.peopleLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[7] || (_cache[7] = [
                          _createElementVNode("div", { class: "flex px-4 py-5 m-auto text-white" }, [
                            _createElementVNode("div", { class: "flex flex-col items-center space-y-6" }, [
                              _createElementVNode("div", { class: "h-20 w-20 bg-brand-lime text-brand-black rounded-full flex" }, [
                                _createElementVNode("div", { class: "m-auto" }, [
                                  _createElementVNode("svg", {
                                    class: "w-7 fill-current",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 512 512"
                                  }, [
                                    _createElementVNode("path", { d: "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" })
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", { class: "flex flex-col w-full items-center space-y-0 px-2" }, [
                                _createElementVNode("div", { class: "flex text-white text-2xl font-medium text-center" }, "Sad times 🙁"),
                                _createElementVNode("div", { class: "text-brand-light-gray text-lg text-center" }, " We couldn't find any users that matched your search, if they're not on Pineapple yet. Give them a nudge! ")
                              ])
                            ])
                          ], -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (!_ctx.search)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[8] || (_cache[8] = [
                          _createElementVNode("div", { class: "flex px-4 py-5 m-auto text-white" }, [
                            _createElementVNode("div", { class: "flex flex-col items-center space-y-6" }, [
                              _createElementVNode("div", { class: "h-20 w-20 bg-brand-lime text-brand-black rounded-full flex" }, [
                                _createElementVNode("div", { class: "m-auto" }, [
                                  _createElementVNode("svg", {
                                    class: "w-7 fill-current",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 512 512"
                                  }, [
                                    _createElementVNode("path", { d: "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" })
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", { class: "flex flex-col w-full items-center space-y-0 px-2" }, [
                                _createElementVNode("div", { class: "flex text-white text-2xl font-medium text-center" }, "Find people you know"),
                                _createElementVNode("div", { class: "text-brand-light-gray text-lg text-center" }, " Find friends and acquaintances you've met at clubs, meets and events. ")
                              ])
                            ])
                          ], -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.peopleLoading)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_11, [...(_cache[9] || (_cache[9] = [
                          _createElementVNode("circle", {
                            class: "opacity-25",
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            "stroke-width": "4"
                          }, null, -1),
                          _createElementVNode("path", {
                            class: "opacity-75",
                            fill: "currentColor",
                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (!_ctx.peopleLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          (_ctx.search.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (user) => {
                                  return (_openBlock(), _createBlock(_component_user_list_item, {
                                    onClick: ($event: any) => (_ctx.viewUserProfile(user.id)),
                                    key: user.id,
                                    user: user
                                  }, null, 8, ["onClick", "user"]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_feed_desktop_sidebar, { class: "feed-desktop-only" })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}